import { Button, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useRemoveClientPoiMutation } from "@/redux/apis/clientPoi/clientPoiApi";
import { PointsOfInterest } from "@/redux/apis/clientPoi/types";
import { addToast, showSnackbar } from "@/utils";

interface RemoveLocationModalProps {
  open: boolean;
  location: PointsOfInterest;
  accountId?: string;
  onClose: () => void;
}

export const RemoveLocationModal = ({ open, location, accountId, onClose }: RemoveLocationModalProps) => {
  const [removePoi, { isLoading }] = useRemoveClientPoiMutation();

  const handleRemove = () => {
    removePoi({ poiId: location.uuid, accountId })
      .unwrap()
      .then(() => {
        showSnackbar({ size: "small", duration: 5000, message: `Removed location ${location.rm_label}` });
        onClose();
      })
      .catch((error) => addToast("danger", getErrorMessages(error)[0]));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      variant="web-small"
      title="Remove Location"
      renderButtons={() => (
        <>
          <Button variant="tertiary" size="md" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="md"
            className="border-danger bg-danger hover:bg-danger-dark"
            onClick={handleRemove}
            disabled={isLoading}
          >
            Remove
          </Button>
        </>
      )}
    >
      <Typography className="text-neutral-dark-gray">
        Are you sure you want to remove <span className="text-info">{location.rm_label}</span> from your favourite list?
      </Typography>
    </Modal>
  );
};
